/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_WaitlistInputs */

const en__field_waitlist = /** @type {(inputs: _Field_WaitlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting List`)
};

const de__field_waitlist = /** @type {(inputs: _Field_WaitlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warteliste`)
};

/**
* | output |
* | --- |
* | "Waiting List" |
*
* @param {_Field_WaitlistInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_waitlist = /** @type {((inputs?: _Field_WaitlistInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_WaitlistInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_waitlist(inputs)
	return de__field_waitlist(inputs)
});